import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as revealActions from '../../../actions/revealActions';
import { bindActionCreators } from 'redux';
import ProfileAvatarSelectorReveal, { AVATAR_SELECTOR_REVEAL } from './reveal/ProfileAvatarSelectorReveal';
import MosaicItem from '../../common/reveal/AvatarMosaic/MosaicItem';

class ProfileImage extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.openImageSelector = this.openImageSelector.bind(this);
    this.getUserPicture = this.getUserPicture.bind(this);
  }

  static propTypes = {
    picture: PropTypes.string,
    revealActions: PropTypes.any,
    avatarsImages: PropTypes.any,
    studentProfile: PropTypes.any
  };

  componentDidUpdate(prevProps) {
    prevProps.studentProfile == this.props.studentProfile;
  }

  openImageSelector() {
    this.props.revealActions.setOpenReveal(AVATAR_SELECTOR_REVEAL);
  }

  getUserPicture() {
    const { picture, avatarsImages } = this.props;
    if (picture) {
      return isNaN(picture) ? picture : avatarsImages[picture];
    }
    return '';
  }

  render() {
    const { studentProfile } = this.props;

    return (
      <Fragment>
        <MosaicItem
          itemClass={'xs'}
          allowImageSelectorLayer={studentProfile ? false : true}
          imageUrl={this.getUserPicture()}
          imageSelectorLayer={this.openImageSelector}
        />
        <ProfileAvatarSelectorReveal onUploadAsset={this.onUploadAsset} />
      </Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    dispatch
  };
}

function mapStateToProps(state) {
  return {
    avatarsImages: state.theme.images.avatars,
    picture: state.account.newUserData.picture,
    studentProfile: state.student.selectedStudent
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileImage);
